// 获取环境变量
export const NODE_ENV = process.env.REACT_APP_ENVIRONMENT || 'local';
export const IS_TEST = NODE_ENV === 'test' || NODE_ENV === 'local';
export const DEPLOY_ENV = NODE_ENV === 'local' ? 'test' : NODE_ENV;
export const APP_KEY = process.env.REACT_APP_APP_KEY;
export const BUILD_DIR = process.env.REACT_APP_BUILD_DIR;
export const CDN_URL = process.env.REACT_APP_CDN_URL;